export const GET_WEATHER_DATA = "GET_WEATHER_DATA";
export const GET_WEATHER_BEGIN = "GET_WEATHER_BEGIN"